import MutationObserver from 'mutation-observer';

import GlobalMenuContainer from './global-menu-container';
import GlobalServicesMenuButton from './global-services-menu-button';
import GlobalSitesMenuButton from './global-sites-menu-button';
import GlobalSupportMenu from './global-menu-support';
import GlobalContextSwitcherButton from './global-context-switcher-button';

export default {

  menu: null,
  servicesMenu: null,
  sitesMenu: null,
  supportMenu: null,
  mutationObserver: null,
  services: null,
  sites: null,

  version: GLOBAL_MENUS_VERSION,

  initialize: function() {
    const url = `https://assets.ctl.io/globalnavigation/services.json?${(new Date()).getTime()}`;

    return fetch(url).then((response) => response.json()).then((config) => {
      this.processConfiguration(config);

      this.initializeMenuElement();
      this.initializeServicesMenu();
      this.initializeSitesMenu();
      this.initializeSupportMenu();
      this.initializeContextSwitcher();

      if (!this.mutationObserver && (!this.menu || !this.servicesMenu || !this.sitesMenu || !this.supportMenu || !this.contextSwitcher)) {
        this.observe();
      }
    }).catch((error) => {
      throw(`[GlobalMenus] There was a problem loading configuration from ${url} - Error: ${error}`);
    });
  },

  processConfiguration(config) {
    this.services = config.services;
    this.sites = config.sites;
  },

  initializeMenuElement: function() {
    if (this.menu) {
      return this.menu;
    }

    const globalMenuElement = document.querySelector('global-menu-container');

    if (globalMenuElement) {
      const options = globalMenuElement.dataset;
      const globalMenuContainer = new GlobalMenuContainer(globalMenuElement, options);
      this.menu = globalMenuContainer;

      return this.menu;
    }

    return false;
  },

  initializeServicesMenu: function() {
    if (this.servicesMenu) {
      return this.servicesMenu;
    }

    const globalServicesMenuElement = document.querySelector('global-services-menu-button');
    if (globalServicesMenuElement && this.menu) {
      const options = globalServicesMenuElement.dataset;
      const globalServicesMenuButton = new GlobalServicesMenuButton(this.menu, globalServicesMenuElement, options, this.services);
      this.servicesMenu = globalServicesMenuButton;

      return this.servicesMenu;
    }

    return false;
  },

  initializeSitesMenu: function() {
    if (this.sitesMenu) {
      return this.sitesMenu;
    }

    const globalSitesMenuElement = document.querySelector('global-sites-menu-button');
    if (globalSitesMenuElement && this.menu) {
      const options = globalSitesMenuElement.dataset;
      const globalSitesMenuButton = new GlobalSitesMenuButton(this.menu, globalSitesMenuElement, options, this.sites);
      this.sitesMenu = globalSitesMenuButton;

      return this.sitesMenu;
    }

    return false;
  },

  initializeContextSwitcher: function() {

    if (this.contextSwitcher) {
      return this.contextSwitcher;
    }

    const globalContextSwitcherElement = document.querySelector('global-context-switcher-button');
    if (globalContextSwitcherElement && this.menu) {
      const options = globalContextSwitcherElement.dataset;
      const globalContextSwitcher = new GlobalContextSwitcherButton(this.menu, globalContextSwitcherElement, options, {});
      this.contextSwitcher = globalContextSwitcher;

      return this.contextSwitcher;
    }

    return false;
  },

  initializeSupportMenu: function() {
    if (this.supportMenu) {
      return this.supportMenu;
    }

    const globalSupportMenuElement = document.querySelector('global-menu-support');
    if (globalSupportMenuElement) {
      const options = globalSupportMenuElement.dataset;
      const globalSupportMenu = new GlobalSupportMenu(globalSupportMenuElement, options);
      this.supportMenu = globalSupportMenu;

      return this.supportMenu;
    }

    return false;
  },

  populateContextSwitcher: function(token, config={}) {
    let camContextSwitcher = document.querySelector('#cam-context-switcher');
    if (camContextSwitcher) {
      return camContextSwitcher.populate(token, config);
    } else {
      return Promise.reject(Error('#cam-context-switcher is not present in document'));
    }
  },

  destroy: function(removeElements = true) {
    this.removeMenu(removeElements);
    this.removeServicesMenu(removeElements);
    this.removeSitesMenu(removeElements);
    this.removeSupportMenu(removeElements);

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  },

  removeMenu: function(removeElement = true) {
    if (!this.menu) { return; }
    this.menu.destroy();
    this.menu = null;

    if (removeElement) {
      const globalMenuElement = document.querySelector('global-menu-container');
      if (globalMenuElement) {
        globalMenuElement.parentNode.removeChild(globalMenuElement);
      }
    }
  },

  removeServicesMenu: function(removeElement = true) {
    if (!this.servicesMenu) { return; }
    this.servicesMenu.destroy();
    this.servicesMenu = null;

    if (removeElement) {
      const globalServicesMenuButtonElement = document.querySelector('global-services-menu-button');
      if (globalServicesMenuButtonElement) {
        globalServicesMenuButtonElement.parentNode.removeChild(globalServicesMenuButtonElement);
      }
    }
  },

  removeSitesMenu: function(removeElement = true) {
    if (!this.sitesMenu) { return; }
    this.sitesMenu.destroy();
    this.sitesMenu = null;

    if (removeElement) {
      const globalSitesMenuButtonElement = document.querySelector('global-sites-menu-button');
      if (globalSitesMenuButtonElement) {
        globalSitesMenuButtonElement.parentNode.removeChild(globalSitesMenuButtonElement);
      }
    }
  },

  removeContextSwitcher: function(removeElement = true) {
    if (!this.contextSwitcher) { return; }
    this.contextSwitcher.destroy();
    this.contextSwitcher = null;

    if (removeElement) {
      const globalContextSwitcherButtonElement = document.querySelector('global-context-switcher-button');
      if (globalContextSwitcherButtonElement) {
        globalContextSwitcherButtonElement.parentNode.removeChild(globalContextSwitcherButtonElement);
      }
    }
  },

  removeSupportMenu: function(removeElement = true) {
    if (!this.supportMenu) { return; }
    this.supportMenu.destroy();
    this.supportMenu = null;

    if (removeElement) {
      const globalSupportMenuElement = document.querySelector('global-menu-support');
      if (globalSupportMenuElement) {
        globalSupportMenuElement.parentNode.removeChild(globalSupportMenuElement);
      }
    }
  },

  observe() {
    const observerOptions = {
      subtree: true,
      attributes: false,
      childList: true,
      characterData: false
    };
    const observedTagNames = [
      'GLOBAL-MENU-CONTAINER', 'GLOBAL-SERVICES-MENU-BUTTON',
      'GLOBAL-SITES-MENU-BUTTON', 'GLOBAL-MENU-SUPPORT',
      'GLOBAL-CONTEXT-SWITCHER-BUTTON'
    ];

    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {

        // Additions
        const addedNodes = [].slice.call(mutation.addedNodes);
        addedNodes.forEach((addedNode) => {
          const tagNameMatches = (observedTagNames.indexOf(addedNode.tagName) >= 0);
          const selectorMatches = (addedNode.querySelector && addedNode.querySelector(observedTagNames));

          if (tagNameMatches || selectorMatches) {
            this.initialize();
          }
        });

        // Removals
        const removedNodes = [].slice.call(mutation.removedNodes);
        removedNodes.forEach((removedNode) => {
          const tagNameMatches = (observedTagNames.indexOf(removedNode.tagName) >= 0);
          const selectorMatches = (removedNode.querySelectorAll && removedNode.querySelectorAll(observedTagNames));

          if (tagNameMatches) {
            this._handleElementRemoval(removedNode);
          } else if (selectorMatches) {
            const selectorMatchesArray = [].slice.call(selectorMatches);
            selectorMatchesArray.forEach((matchedNode) => {
              this._handleElementRemoval(matchedNode);
            });
          }
        });

      });
    });

    this.mutationObserver.observe(document, observerOptions);
  },

  _handleElementRemoval: function(element) {
    switch(element.tagName) {
    case 'GLOBAL-MENU-CONTAINER':
      this.removeMenu(false);
      break;
    case 'GLOBAL-SERVICES-MENU-BUTTON':
      this.removeServicesMenu(false);
      break;
    case 'GLOBAL-SITES-MENU-BUTTON':
      this.removeSitesMenu(false);
      break;
    case 'GLOBAL-MENU-SUPPORT':
      this.removeSupportMenu(false);
      break;
    case 'GLOBAL-CONTEXT-SWITCHER-BUTTON':
      this.removeContextSwitcher(false);
      break;
    default:
      throw(`[GlobalMenus] Asked to remove an unknown element type: ${element.tagName}!`);
    }
  }

};



// WEBPACK FOOTER //
// ./src/scripts/global-menus.js